import { FlexAligner, Typography } from '@scaleaq/scaleui';

import { responsive } from '@/utils';

import { SiteCard } from './siteCardsGroup/SiteCard.tsx';
import { SiteCardsGrid } from './siteCardsGroup/siteCardsGroup.styles.ts';
import { SiteCardWithHealth } from './siteCardsGroup/siteCardsGroup.types.ts';

type SiteCardsGroupProps = {
  label?: string | undefined;
  items: SiteCardWithHealth[];
  onSelect: (siteId: string) => void;
};

export const SiteCardsGroup = ({ label, items, onSelect }: SiteCardsGroupProps) => {
  return (
    <FlexAligner direction='column' gap={responsive.spacing.large} alignment='top-left'>
      {label && (
        <Typography type='heading_xsmall' secondary>
          {label}
        </Typography>
      )}
      <SiteCardsGrid>{renderSiteCards(items, onSelect)}</SiteCardsGrid>
    </FlexAligner>
  );
};

const renderSiteCards = (items: SiteCardWithHealth[], onSelect: (siteId: string) => void) =>
  items.map(item => (
    <SiteCard
      health={item.health}
      isPending={item.health == null}
      key={item.site.id}
      name={item.site.name}
      onClick={() => onSelect(item.site.id)}
      selected={item.selected}
      supportedServices={item.supportedServices}
    />
  ));
